import { render, staticRenderFns } from "./discountximeiCard.vue?vue&type=template&id=670c2a54&scoped=true&"
import script from "./discountximeiCard.vue?vue&type=script&lang=js&"
export * from "./discountximeiCard.vue?vue&type=script&lang=js&"
import style0 from "./discountximeiCard.vue?vue&type=style&index=0&id=670c2a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c2a54",
  null
  
)

export default component.exports